import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const FolderIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 28 28" fill="none"  >
    <g clipPath="url(#clip0)">
      <path d="M23.45 4H10.545C10.215 4 9.89 3.5 9.89 3.5L9.035 2.85C8.81854 2.69009 8.57447 2.57144 8.315 2.5H5C4.60218 2.5 4.22064 2.65804 3.93934 2.93934C3.65804 3.22064 3.5 3.60218 3.5 4V10.22C3.5 10.6178 3.65804 10.9994 3.93934 11.2807C4.22064 11.562 4.60218 11.72 5 11.72H23.5C23.8978 11.72 24.2794 11.562 24.5607 11.2807C24.842 10.9994 25 10.6178 25 10.22V5.5C24.9908 5.09638 24.823 4.71263 24.5329 4.43187C24.2428 4.15111 23.8537 3.99595 23.45 4Z" fill="#FFBE32" />
      <path d="M2.5 5.5H25.5V10.665H2.5V5.5Z" fill="#E8E4C8" />
      <path d="M1.5 7H26.46V12.25L1.5 12.23V7Z" fill="#EFEFEF" />
      <path d="M1.315 8H26.69C27.0388 8.00395 27.372 8.14529 27.6172 8.39335C27.8625 8.64141 28 8.97617 28 9.325V25.675C28 26.0238 27.8625 26.3586 27.6172 26.6067C27.372 26.8547 27.0388 26.9961 26.69 27H1.315C0.965324 26.9974 0.630868 26.8566 0.384541 26.6084C0.138214 26.3602 -9.95862e-06 26.0247 5.38136e-10 25.675L5.38136e-10 9.325C-9.95862e-06 8.97531 0.138214 8.6398 0.384541 8.3916C0.630868 8.1434 0.965324 8.00264 1.315 8Z" fill="#FFDD50" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
FolderIcon.displayName = "FolderIcon";
FolderIcon.muiName = "SvgIcon";

export default pure(FolderIcon);